/**
 * Shopflo Recovery 2.0: Redirects users from native /cart to Home
 * and automatically opens the Shopflo drawer for a seamless experience.
 */
(function() {
  var urlParams = new URLSearchParams(window.location.search);
  var isCartPage = window.location.pathname.indexOf('/cart') !== -1;
  var shouldOpen = urlParams.has('shopflo_open');

  // 1. If we are on the native cart page, redirect to home with the trigger param
  if (isCartPage && !shouldOpen) {
    console.log('[Nutrikorner] Native cart detected. Redirecting to home to trigger Shopflo...');
    window.location.href = '/?shopflo_open=true';
    return;
  }

  // 2. If the trigger param is present, wait for Shopflo and open it
  if (shouldOpen) {
    console.log('[Nutrikorner] Shopflo trigger detected. Waiting for Shopflo...');
    var attempts = 0;
    var recoveryInterval = setInterval(function() {
      attempts++;
      if (typeof window.handleFloCartBtn === 'function') {
        console.log('[Nutrikorner] Shopflo found. Opening drawer...');
        
        // Signal refresh and Open
        window.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        setTimeout(function() { 
          window.handleFloCartBtn(); 
          
          // 3. Cleanup: Remove the parameter from the URL bar without reloading
          var newParams = new URLSearchParams(window.location.search);
          newParams.delete('shopflo_open');
          var searchStr = newParams.toString();
          var newUrl = window.location.pathname + (searchStr ? '?' + searchStr : '');
          window.history.replaceState({}, '', newUrl);
          console.log('[Nutrikorner] Shopflo opened and URL cleaned.');
        }, 200);
        
        clearInterval(recoveryInterval);
      } else if (attempts > 40) {
        clearInterval(recoveryInterval);
        console.warn('[Nutrikorner] Shopflo recovery timed out.');
      }
    }, 500);
  }
})();
